import type { ReactNode } from 'react';

import { activatableProps } from '@/admin/components/activatable';
import styles from '@/admin/components/AdminTable.module.scss';

export const AdminTable = ({ children }: { children: ReactNode }) => (
  <div className={styles.wrapper}>
    <table className={styles.table}>{children}</table>
  </div>
);

export const AdminTableHead = ({ children }: { children: ReactNode }) => (
  <thead>
    <tr>{children}</tr>
  </thead>
);

export const AdminTableHeadCell = ({ children }: { children: ReactNode }) => (
  <th className={styles.head}>{children}</th>
);

type AdminTableRowProps = {
  children: ReactNode;
  /** Makes the whole row open something; the controls inside it still act on their own. */
  onActivate?: () => void;
};

export const AdminTableRow = ({ children, onActivate }: AdminTableRowProps) => (
  <tr
    className={`${styles.row} ${onActivate ? styles.interactive : ''}`}
    {...activatableProps(onActivate)}
  >
    {children}
  </tr>
);

export const AdminTableCell = ({ children }: { children: ReactNode }) => (
  <td className={styles.cell}>{children}</td>
);
